import React from "react";
import Loader from '../../../components/Loader';
import Page from '../../../components/Page';
import HTTPManager from "../../../utils/httpRequestManager";
import TableView from '../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from '../../../components/Iconify';
import FormManager from "../../../components/formComponents/FormManager";
import schema from './schema.json';
import {Box, Grid, Card,  Container, Typography, Stack, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton} from '@mui/material';
import FButton from '../../../components/formComponents/components/button';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { checkButtonAccess } from '../../../utils/protector'
import { Email } from "@mui/icons-material";
import dayjs from "dayjs";
const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class Customer extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            schema:{},
            customerlist:[],
            statesList:[],
            addForm: false,
            selectedcustomer:{},
            columns:[
                {
                    field: 'mCustomerName',
                    headerName: 'Name',
                    minWidth:200,
                    flex:1,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                            {params.row.mCustomerName === ''? '--' : params.row.mCustomerName }
                        </div>
                    )
                },
                {
                    field: 'mCustomerMemberId',
                    headerName: 'Member ID',
                    minWidth:200,
                    flex:1,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                           {params.row.mCustomerMemberId === ''? '--' : params.row.mCustomerMemberId}
                        </div>
                    )
                },
                {
                    field: 'mCustomertPhone',
                    headerName: 'Phone',
                    minWidth:150,
                    flex:1,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                          {params.row.mCustomerMobile === '' ? '--' : params.row.mCustomerMobile}
                        </div>
                    )
                }, 
                {
                    field: 'Action',
                    headerName:'Actions',
                    flex:1,
                    minWidth:100,
                    renderCell: (params) => (
                        this.getActions(params)                    
                    ),
                }  
            ],
        }
        this.handleCloseform = this.handleCloseform.bind(this); 
        this.updateRecord = this.updateRecord.bind(this);
    }
    updateRecord(row, status){ 
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`merchant/customers/updateCustomer`, {mCustomerStatus: status, id: row.id}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }
    componentDidMount(){ 
        this.setState({schema: schema},()=>{
            this.reloadData();
        })
    }
    handleCloseform(){
        this.setState({addForm: false})
    }
    getActions(params){
        //console.log("params",params);
        var detail = window.localStorage.getItem('userdetail')
        if(detail !== '' && detail !== undefined && detail !=='{}'){
          var userdetail = JSON.parse(detail);
        return <div>       
                
                {( checkButtonAccess('Customer') === 'W'  || userdetail.userRole==='Owner') && <FButton  permission_id = "web_edit_customer" permission_label="Show edit customer"
                variant="outlined" 
                size="small" 
                onClick={()=>this.openEdit(params.row)} 
                label="Edit"/>}
                
                {(checkButtonAccess('Customer') === 'W'  ||  userdetail.userRole==='Owner') &&  params.row.mCustomerStatus.toString() === '1'  &&
                    <FButton permission_id = "web_status_customer" permission_label="Show status customer"
                    variant="contained" 
                    size="small" 
                    onClick={()=>{this.updateRecord(params.row, 0)}} 
                    label="Deactivate"/>
                }
                {(checkButtonAccess('Customer') === 'W'  ||  userdetail.userRole==='Owner') &&  params.row.mCustomerStatus.toString()==='0'  && 
                    <FButton permission_id = "web_status_customer" permission_label="Show status customer"
                    variant="contained" 
                    size="small" 
                    onClick={()=>{this.updateRecord(params.row, 1)}} 
                    label="Activate"/>
                }

                {checkButtonAccess('Customer') !== 'W'  &&  userdetail.userRole !=='Owner' && <div>N/A</div>}
               
            </div>
        }
    }
    openEdit(data){ 
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var props=[];
        properties.forEach((field,i)=>{
            field.value = data[field.name];
            props.push(field);
            if(i === properties.length-1){
                props.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                schema.properties = props; 
                this.setState({schema: schema,selectedcustomer: data},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }
    reloadData(msg=''){
        //console.log("111")
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`merchant/customers/getCustomer`).then(response=>{
                //console.log(response)
                this.setState({customerlist: response.data, isLoading: false});
            })

            // Load the state lookup so import/export can map between the stored
            // state id (mCustomerState) and the human state name.
            if (!this.state.statesList || this.state.statesList.length === 0) {
                this.httpManager.getRequest(`lookup/getStates`).then((r) => {
                    this.setState({ statesList: (r && r.data) || [] });
                }).catch(() => {});
            }

            // this.httpManager.getRequest(`merchant/customers/getCustomer`).then(response=>{
            //     var data = [];
            //     //console.log("response",response.data);
            //     if(response.data.length > 0){
            //         response.data.forEach((elmt, i)=>{ 
            //             elmt.id = elmt.mCustomerId;
            //             data.push(elmt);
            //             if(i === response.data.length-1){
            //                 this.setState({customerlist: data, isLoading: false});
            //             }
            //         })
            //     }
            //     else{
            //         this.setState({customerlist: data, isLoading: false});
            //     }
            // })
        })
    }
    openAdd(){
        this.setState({schema: schema,selectedcustomer: {}},()=>{
            var schemaobj = Object.assign({}, schema);

            var properties = Object.assign([], this.state.schema.properties);
            var props=[];
            properties.forEach((field,i)=>{
                delete field["value"];
                props.push(field);
                if(i === properties.length-1){
                    schemaobj.properties = props;
                }
            });
            this.setState({schema:schemaobj}, ()=>{
                this.setState({addForm: true}) 
            })
        })
    }

    // Build lookups between the stored state id (what mCustomerState holds) and
    // the human state name, so Excel shows the NAME, and import accepts the name.
    buildStateMaps = () => {
        const states = this.state.statesList || [];
        const idToName = {};
        const nameToId = {};
        states.forEach((s) => {
            const id = s.id != null ? String(s.id) : "";
            const nm = String(s.stateName || "").trim();
            if (id) idToName[id] = nm;
            if (nm) {
                nameToId[nm.toLowerCase()] = s.id; // full "Florida FL"
                const parts = nm.split(/\s+/);
                if (parts.length > 1) {
                    nameToId[parts[parts.length - 1].toLowerCase()] = s.id; // abbrev "FL"
                    nameToId[parts.slice(0, -1).join(" ").toLowerCase()] = s.id; // "Florida"
                }
            }
        });
        return { idToName, nameToId };
    };

    exportToExcel = () => {
    const { customerlist } = this.state;
    if (!customerlist || customerlist.length === 0) {
        toast.warn("No data to export");
        return;
    }

    const { idToName } = this.buildStateMaps();
    const exportData = customerlist.map((item) => ({
        Name: item.mCustomerName || '--',
        Mobile: item.mCustomerMobile || '--',
        "Birthday": item.mCustomerDOB ? dayjs(item.mCustomerDOB).format('YYYY-MM-DD') : '--',
        Email: item.mCustomerEmail || '--',
        "Address 1": item.mCustomerAddress1 || '--',
        "Address 2": item.mCustomerAddress2 || '--',
        City: item.mCustomerCity || '--',
        State: idToName[String(item.mCustomerState)] || item.mCustomerState || '--',
        Zip: item.mCustomerZipcode || '--',
        "Loyalty Points": item.mCustomerLoyaltyPoints != null ? item.mCustomerLoyaltyPoints : 0,
        Status: item.mCustomerStatus?.toString() === '1' ? "Active" : "Inactive"
        }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `CustomerList_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

    // ---- Import (xlsx / csv) --------------------------------------------------
    // Accepts the same columns the export produces (case-insensitive headers).
    triggerImport = () => {
        if (this.fileInputRef) this.fileInputRef.click();
    };

    // Download a ready-to-fill example file with the exact headers the import
    // expects (including Loyalty Points), plus one sample row for guidance.
    downloadTemplate = () => {
        const headers = ["Name", "Mobile", "Email", "Birthday", "Address 1", "Address 2", "City", "State", "Zip", "Loyalty Points"];
        const example = [{
            Name: "John Doe",
            Mobile: "5551234567",
            Email: "john@example.com",
            Birthday: "1990-05-20",
            "Address 1": "123 Main St",
            "Address 2": "",
            City: "Dallas",
            State: "TX",
            Zip: "75001",
            "Loyalty Points": 0,
        }];
        const ws = XLSX.utils.json_to_sheet(example, { header: headers });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Customers");
        const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        saveAs(new Blob([buf], { type: "application/octet-stream" }), "Customer_Import_Template.xlsx");
    };

    // Choosing a file only stores it (and shows its name) — the actual import
    // runs when the user clicks the Import button (runImport).
    handleImportFile = (e) => {
        const file = e.target.files && e.target.files[0];
        e.target.value = ""; // allow re-selecting the same file
        if (!file) return;
        this.setState({ importFile: file, importFileName: file.name });
    };

    runImport = () => {
        const file = this.state.importFile;
        if (!file) { toast.warn("Please choose a file first."); return; }
        this.setState({ showImportDialog: false });
        const reader = new FileReader();
        reader.onload = (evt) => {
            try {
                const wb = XLSX.read(evt.target.result, { type: "array" });
                const ws = wb.Sheets[wb.SheetNames[0]];
                const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });
                this.importCustomers(rows);
            } catch (err) {
                toast.error("Could not read the file. Please use a valid .xlsx or .csv.");
            }
        };
        reader.readAsArrayBuffer(file);
        this.setState({ importFile: null, importFileName: "" });
    };

    importCustomers = async (rows) => {
        // read a value by any of the accepted header names (case-insensitive)
        const pick = (row, names) => {
            for (const key of Object.keys(row)) {
                if (names.indexOf(key.trim().toLowerCase()) !== -1) {
                    return String(row[key] == null ? "" : row[key]).trim();
                }
            }
            return "";
        };
        // Phone is stored as 10 digits (schema: maxLength 10). Normalize to digits.
        const normPhone = (v) => String(v == null ? "" : v).replace(/\D/g, "");
        // Existing numbers for THIS merchant (getCustomer is merchant-scoped).
        const existing = new Set(
            (this.state.customerlist || [])
                .map((x) => normPhone(x.mCustomerMobile))
                .filter(Boolean),
        );
        const seenInFile = new Set();
        const toSave = [];
        const errors = [];
        // Map the State cell (name "Florida FL", "Florida", abbrev "FL", or a raw
        // id) back to the stored state id that mCustomerState expects.
        const { nameToId } = this.buildStateMaps();
        const resolveState = (raw) => {
            const v = String(raw == null ? "" : raw).trim();
            if (!v) return "";
            const byName = nameToId[v.toLowerCase()];
            if (byName != null) return byName;
            return v; // already an id (or unknown) — pass through unchanged
        };

        rows.forEach((r, idx) => {
            const rowNo = idx + 2; // +1 header row, +1 for 1-based row numbering
            const name = pick(r, ["name", "customer name", "mcustomername"]);
            const rawPhone = pick(r, ["phone", "phone number", "mobile", "mcustomermobile"]);
            if (!name && !rawPhone) return; // blank row — ignore silently

            // --- phone validation ---
            let phone = normPhone(rawPhone);
            if (phone.length === 11 && phone.charAt(0) === "1") phone = phone.slice(1); // drop US country code
            if (!rawPhone) { errors.push(`Row ${rowNo}: missing phone number`); return; }
            if (!/^\d{10}$/.test(phone)) {
                errors.push(`Row ${rowNo}: invalid phone "${rawPhone}" — must be 10 digits`);
                return;
            }
            // --- duplicate checks (per this merchant) ---
            if (existing.has(phone)) {
                errors.push(`Row ${rowNo}: ${phone} already exists for this merchant — skipped`);
                return;
            }
            if (seenInFile.has(phone)) {
                errors.push(`Row ${rowNo}: ${phone} is duplicated in the file — skipped`);
                return;
            }
            seenInFile.add(phone);

            const c = {
                mCustomerName: name,
                mCustomerMobile: phone,
                mCustomerEmail: pick(r, ["email", "mcustomeremail"]),
                mCustomerDOB: pick(r, ["birthday", "dob", "date of birth", "mcustomerdob"]),
                mCustomerAddress1: pick(r, ["address", "address1", "address 1", "mcustomeraddress1"]),
                mCustomerAddress2: pick(r, ["address2", "address 2", "mcustomeraddress2"]),
                mCustomerCity: pick(r, ["city", "mcustomercity"]),
                mCustomerState: resolveState(pick(r, ["state", "mcustomerstate"])),
                mCustomerZipcode: pick(r, ["zipcode", "zip", "mcustomerzipcode"]),
                // NOT-NULL columns the import doesn't collect — default to 0
                // (the Add form sets these; without them the insert fails).
                mCustomerTotalVisit: 0,
                mCustomerTotalSpent: 0,
            };
            // Only send loyalty when a valid number is present (backend logs an
            // "Earned" entry whenever mCustomerLoyaltyPoints is defined).
            const lp = pick(r, ["loyalty points", "loyaltypoints", "loyalty", "points", "mcustomerloyaltypoints"]);
            if (lp !== "" && !isNaN(Number(lp))) c.mCustomerLoyaltyPoints = Number(lp);
            toSave.push(c);
        });

        if (toSave.length === 0) {
            toast.warn(`Nothing to import — ${errors.length} row(s) had issues.`);
            if (errors.length) {
                console.warn("Import validation issues:\n" + errors.join("\n"));
                toast.error(errors.slice(0, 6).join("  |  "));
            }
            return;
        }

        this.setState({ isLoading: true });
        let added = 0, failed = 0;
        for (const c of toSave) {
            try {
                await this.httpManager.postRequest(`merchant/customers/save`, c);
                added++;
            } catch (err) {
                failed++;
                errors.push(`${c.mCustomerMobile}: server rejected (${(err && err.response && err.response.status) || "error"})`);
            }
        }
        this.reloadData();
        toast.success(`Import complete — ${added} added, ${errors.length} skipped/invalid.`);
        if (errors.length) {
            console.warn("Import issues:\n" + errors.join("\n"));
            toast.error("Issues: " + errors.slice(0, 6).join("  |  "));
        }
    };

    render(){
        return <Page title="Customer | Astro POS">
                {this.state.isLoading && <Loader show={this.state.isLoading} />}
                <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />
            {!this.state.addForm ? 
                <Container maxWidth="large">
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                    Customer Management
                    </Typography>
                    
                    {checkButtonAccess('Customer') === 'W' && (
                    <Stack direction="row" spacing={1}>
                        <FButton 
                        onClick={() => this.openAdd()}
                        size="medium"
                        variant="contained"
                        label="Add Customer"
                        startIcon={getIcon('mdi:plus')}
                        />
                        <FButton
                        onClick={this.exportToExcel}
                        size="medium"
                        variant="outlined"
                        label="Export to Excel"
                        startIcon={getIcon('mdi:file-excel')}
                        />
                        <FButton
                        onClick={() => this.setState({ showImportDialog: true })}
                        size="medium"
                        variant="outlined"
                        label="Import"
                        startIcon={getIcon('mdi:file-upload')}
                        />
                        <input
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        ref={(el) => (this.fileInputRef = el)}
                        style={{ display: 'none' }}
                        onChange={this.handleImportFile}
                        />
                    </Stack>
                    )}
                </Stack>

                <Card>
                    <TableView
                    data={this.state.customerlist} 
                    columns={this.state.columns} />
                </Card>
                </Container> : ''
            }
            {this.state.addForm && <Box sx={{ width: '100%' }}>
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} >
                     <Grid item xs={12}>
                        <Stack spacing={3}>
                            <FormManager formProps={this.state.schema}  reloadData={(msg)=>this.reloadData(msg)} closeForm={()=>this.handleCloseform()}/>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>}

            <Dialog open={!!this.state.showImportDialog} onClose={() => this.setState({ showImportDialog: false })} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ pr: 6 }}>
                    Import Customers
                    <IconButton onClick={() => this.setState({ showImportDialog: false })} sx={{ position: 'absolute', right: 8, top: 8 }}>
                        {getIcon('mdi:close')}
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                        Upload an Excel/CSV file with these columns: <b>Name, Phone, Email, DOB, Address1, Address2, City, State, Zipcode, Loyalty Points</b>.
                        Phone must be 10 digits and unique. Not sure of the format? Download the example file first.
                    </Typography>
                    <Stack spacing={1.5}>
                        <Button onClick={this.downloadTemplate} variant="outlined" fullWidth startIcon={getIcon('mdi:download')}>
                            Download Example File
                        </Button>
                        <Button onClick={this.triggerImport} variant="outlined" fullWidth startIcon={getIcon('mdi:file-upload')}>
                            Choose File
                        </Button>
                        {this.state.importFileName && (
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Selected: <b>{this.state.importFileName}</b>
                            </Typography>
                        )}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ showImportDialog: false, importFile: null, importFileName: "" })}>Cancel</Button>
                    <Button onClick={this.runImport} variant="contained" disabled={!this.state.importFile} startIcon={getIcon('mdi:check')}>
                        Import
                    </Button>
                </DialogActions>
            </Dialog>
            </Page>
    }
}